/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PtOtCaseMixGroupScoreRange } from './PtOtCaseMixGroupScoreRange';
import {
    PtOtCaseMixGroupScoreRangeFromJSON,
    PtOtCaseMixGroupScoreRangeFromJSONTyped,
    PtOtCaseMixGroupScoreRangeToJSON,
    PtOtCaseMixGroupScoreRangeToJSONTyped,
} from './PtOtCaseMixGroupScoreRange';
import type { PtOtClinicalCategory } from './PtOtClinicalCategory';
import {
    PtOtClinicalCategoryFromJSON,
    PtOtClinicalCategoryFromJSONTyped,
    PtOtClinicalCategoryToJSON,
    PtOtClinicalCategoryToJSONTyped,
} from './PtOtClinicalCategory';

/**
 * 
 * @export
 * @interface PtOtClinicalCategoryToCaseMixGroupMapping
 */
export interface PtOtClinicalCategoryToCaseMixGroupMapping {
    /**
     * 
     */
    clinical_category: PtOtClinicalCategory;
    /**
     * 
     */
    case_mix_groups: Array<PtOtCaseMixGroupScoreRange>;
}



/**
 * Check if a given object implements the PtOtClinicalCategoryToCaseMixGroupMapping interface.
 */
export function instanceOfPtOtClinicalCategoryToCaseMixGroupMapping(value: object): value is PtOtClinicalCategoryToCaseMixGroupMapping {
    if (!('clinical_category' in value) || value['clinical_category'] === undefined) return false;
    if (!('case_mix_groups' in value) || value['case_mix_groups'] === undefined) return false;
    return true;
}

export function PtOtClinicalCategoryToCaseMixGroupMappingFromJSON(json: any): PtOtClinicalCategoryToCaseMixGroupMapping {
    return PtOtClinicalCategoryToCaseMixGroupMappingFromJSONTyped(json, false);
}

export function PtOtClinicalCategoryToCaseMixGroupMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): PtOtClinicalCategoryToCaseMixGroupMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'clinical_category': PtOtClinicalCategoryFromJSON(json['clinical_category']),
        'case_mix_groups': ((json['case_mix_groups'] as Array<any>).map(PtOtCaseMixGroupScoreRangeFromJSON)),
    };
}

export function PtOtClinicalCategoryToCaseMixGroupMappingToJSON(json: any): PtOtClinicalCategoryToCaseMixGroupMapping {
    return PtOtClinicalCategoryToCaseMixGroupMappingToJSONTyped(json, false);
}

export function PtOtClinicalCategoryToCaseMixGroupMappingToJSONTyped(value?: PtOtClinicalCategoryToCaseMixGroupMapping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clinical_category': PtOtClinicalCategoryToJSON(value['clinical_category']),
        'case_mix_groups': ((value['case_mix_groups'] as Array<any>).map(PtOtCaseMixGroupScoreRangeToJSON)),
    };
}

